import { Caution } from '@icon-park/react'
import { AlertsContainer } from './ContentAlerts.styles'
import { Icon, Tooltip } from '@/components'
import { Tokens } from '@/assets/tokens'

interface ContentAlertsProps {
  hasNoContent?: boolean
  hasTitleEqualsContent?: boolean
}

export function ContentAlerts({ hasNoContent, hasTitleEqualsContent }: ContentAlertsProps) {
  const showAlerts = hasNoContent || hasTitleEqualsContent

  if (!showAlerts) {
    return <AlertsContainer />
  }

  return (
    <AlertsContainer>
      {hasNoContent && (
        <Tooltip value="A postagem não contém conteúdo">
          <Icon size={18} value={Caution} color={Tokens.ColorUIDanger}></Icon>
        </Tooltip>
      )}

      {hasTitleEqualsContent && (
        <Tooltip value="Título igual ao conteúdo">
          <Icon size={18} value={Caution} color={Tokens.ColorUIWarn}></Icon>
        </Tooltip>
      )}
    </AlertsContainer>
  )
}
